// extracted by css-extract-rspack-plugin
export default {"pureLink":"customer-communication-fragment__PureLink_pureLink__G0LVq"};